import { useMemo } from 'react';

import { useOrganizationClustersDailyCostsQuery } from '@cast/shared-cost-data-access';

import { useClustersOverviewDateRange } from '@cast/features-cluster-shared';
import { mapClustersDailyCostsToSpendBreakdown } from '@cast/features-cluster-shared-utils';

export const useDashboardCostChartData = () => {
  const range = useClustersOverviewDateRange();
  const { data, isLoading, isFetching, error, refetch } =
    useOrganizationClustersDailyCostsQuery({
      range,
    });

  const {
    chartData,
    currentSpendMonthly,
    onDemandSpendMonthly,
    spotSpendMonthly,
    fallbackSpendMonthly,
  } = useMemo(
    () => mapClustersDailyCostsToSpendBreakdown({ report: data }),
    [data]
  );

  return {
    chartData,
    currentSpendMonthly,
    onDemandSpendMonthly,
    spotSpendMonthly,
    fallbackSpendMonthly,
    isLoading,
    error: isFetching ? undefined : error,
    refetch,
  };
};
